import { API_URL, BID_REQUEST_TYPE } from "../Config/config";
import { fetchApiData, getLocalStorageItem } from "../Helper/helper";

export const getInActiveBids = async () => {
   const response = await fetchApiData(`${API_URL}/seller/bidRequestOrders?bidRequestType=inactive`, {
      method: "GET",
      headers: {
         "Content-Type": "application/json",
         authToken: getLocalStorageItem("ORDER_AUTH_TOKEN"),
      }
   });
   return response;
}

export const getSellerBids = async (bidRequestType, page, perPageLimit, search, sortBy, sortType, orderStatus) => {
   const path = "/v1/seller/bidRequestOrders";
   const queryParams = {
      bidRequestType
   };
   if (page) queryParams.pageNo = page;
   if (perPageLimit) queryParams.limit = perPageLimit;
   if (search) queryParams.search = search;
   if (sortBy) queryParams.sortBy = sortBy;
   if (sortType) queryParams.order = sortType;
   if (orderStatus && orderStatus !== "all") queryParams.orderStatus = orderStatus;

   const url = new URL(path, API_URL);

   // Add query parameters to the URL
   Object.keys(queryParams).forEach(key => {
      url.searchParams.append(key, queryParams[key]);
   });

   const response = await fetchApiData(url, {
      method: "GET",
      headers: {
         "Content-Type": "application/json",
         authToken: getLocalStorageItem("ORDER_AUTH_TOKEN"),
      }
   });
   return response;
}

export const getLogisticsBids = async (bidRequestType, page, perPageLimit, search) => {
   const path = "/v1/logistic/get-order-list";
   const queryParams = {
      type: bidRequestType
   };
   if (page) queryParams.pageNo = page;
   if (perPageLimit) queryParams.limit = perPageLimit;
   if (search) queryParams.search = search;

   const url = new URL(path, API_URL);

   // Add query parameters to the URL
   Object.keys(queryParams).forEach(key => {
      url.searchParams.append(key, queryParams[key]);
   });

   const response = await fetchApiData(url, {
      method: "GET",
      headers: {
         "Content-Type": "application/json",
         authToken: getLocalStorageItem("ORDER_AUTH_TOKEN"),
      }
   });
   return response;
}

export const getSellerBidRequestDetailsFromBidId = async (bidId) => {
   const response = await fetchApiData(
      `${API_URL}/seller/bidRequest/${bidId}`,
      {
         method: "GET",
         headers: {
            "Content-Type": "application/json",
         },
      }
   );
   return response;
}

export const postRatingsFromSellerToLogistics = async (bidId, reqObj) => {
   const response = await fetchApiData(
      `${API_URL}/seller/rateReview/${bidId}`,
      {
         method: "POST",
         headers: {
            "Content-Type": "application/json",
         },
         body: JSON.stringify(reqObj),
      }
   );
   return response;
}